import React, { useState } from 'react';

import Select from 'components/elements/Select';
import SelectOptionArray from 'types/model/selectOption';
import { customFetch } from 'utils/fetch';
import Routes from 'routes';

export interface PipelineStageSelectProps {
  leadId: number;
  value: string | null;
}

const PIPELINE_STAGES = [
  'lead',
  'contacted',
  'replied',
  'meeting',
  'opportunity',
  'lost',
  'follow_up',
];

const stageOptions: SelectOptionArray = PIPELINE_STAGES.map((stage) => ({
  id: stage,
  value: stage,
  name: I18n.translate(`customer_leads.pipeline_stage.${stage}`),
}));

const PipelineStageSelect = ({ leadId, value }: PipelineStageSelectProps) => {
  const [currentValue, setCurrentValue] = useState(value || '');
  const [saving, setSaving] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;
    const previousValue = currentValue;
    setCurrentValue(newValue);
    setSaving(true);

    customFetch(
      Routes.update_pipeline_stage_customer_lead_path(leadId),
      { customer_lead: { pipeline_stage: newValue } },
      'PATCH'
    )
      .then((response: any) => {
        if (response?.errors) {
          setCurrentValue(previousValue);
          window.alert(response.errors[0]);
        }
      })
      .catch(() => {
        setCurrentValue(previousValue);
      })
      .finally(() => setSaving(false));
  };

  return (
    <Select
      options={stageOptions}
      value={currentValue}
      onChange={handleChange}
      disabled={saving}
      placeholder='—'
      style={{ minWidth: '10em' }}
    />
  );
};

export default PipelineStageSelect;
